export default "__VITE_ASSET__CrBja$Px__"